/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  OrgCompassDeviceListItemResponse,
} from '../models/index';
import {
    OrgCompassDeviceListItemResponseFromJSON,
    OrgCompassDeviceListItemResponseToJSON,
} from '../models/index';

export interface ApiOrgCompassDevicesGetAllGetRequest {
    orgCode?: string;
}

/**
 * 
 */
export class OrgCompassDevicesApi extends runtime.BaseAPI {

    /**
     */
    async apiOrgCompassDevicesGetAllGetRaw(requestParameters: ApiOrgCompassDevicesGetAllGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OrgCompassDeviceListItemResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['orgCode'] != null) {
            queryParameters['org_code'] = requestParameters['orgCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgCompassDevices/GetAll`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OrgCompassDeviceListItemResponseFromJSON));
    }

    /**
     */
    async apiOrgCompassDevicesGetAllGet(requestParameters: ApiOrgCompassDevicesGetAllGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OrgCompassDeviceListItemResponse>> {
        const response = await this.apiOrgCompassDevicesGetAllGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
